import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterCBondsOfferTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "DataFechamento": dayjs().format(DATE_FORMAT),
            "DataAbertura": dayjs().format(DATE_FORMAT),
            "IDPaisEmitente": null,
            "IDRegiaoPaisEmitente": null,
            "IDEmitente": null,
            "IDEmissao": null,
            "ISIN": null,
            "ISIN144a": null,
            "MaisInformacoesEng": null,
            "MaisInformacoesIta": null,
            "MaisInformacoesPol": null,
            "MaisInformacoesRus": null,
            "Preco": null,
            "QtdRecomprada": null,
            "StatusStr": null,
            "TipoEng": null,
            "TipoID": null,
            "TipoIta": null,
            "TipoPol": null,
            "TipoRus": null,
            "DataAtualizacao": dayjs().format(DATE_FORMAT),
            "IDTipoOperacao": null,
            "NomeTipoOpcao_Rus": null,
            "NomeTipoOpcao_Eng": null,
            "PeriodoAviso": null,
            "SpreadBenchmark": null,
            "DataLimite": null,
            "IDTipoEmitente": null,
            "DataInicioColocacao": dayjs().format(DATE_FORMAT),
            "DataFimColocacao": dayjs().format(DATE_FORMAT),
            "IDStatusEmissao": null,
            "NomeEmitenteEng": null,
            "NomeEmitenteRus": null,
            "IDFilialEmitente": null,
            "IDTipoEmissao": null,
            "MercadoNegociacaoAtual": null
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, DataReferencia, DataFechamento, DataAbertura, IDPaisEmitente, IDRegiaoPaisEmitente, IDEmitente, IDEmissao, ISIN, ISIN144a, MaisInformacoesEng, MaisInformacoesIta, MaisInformacoesPol, MaisInformacoesRus, Preco, QtdRecomprada, StatusStr, TipoEng, TipoID, TipoIta, TipoPol, TipoRus, DataAtualizacao, IDTipoOperacao, NomeTipoOpcao_Rus, NomeTipoOpcao_Eng, PeriodoAviso, SpreadBenchmark, DataLimite, IDTipoEmitente, DataInicioColocacao, DataFimColocacao, IDStatusEmissao, NomeEmitenteEng, NomeEmitenteRus, IDFilialEmitente, IDTipoEmissao, MercadoNegociacaoAtual
        } = newRow

        const body = {
            "DataReferencia": DataReferencia,
            "DataFechamento": DataFechamento,
            "DataAbertura": DataAbertura,
            "IDPaisEmitente": IDPaisEmitente,
            "IDRegiaoPaisEmitente": IDRegiaoPaisEmitente,
            "IDEmitente": IDEmitente,
            "IDEmissao": IDEmissao,
            "ISIN": ISIN,
            "ISIN144a": ISIN144a,
            "MaisInformacoesEng": MaisInformacoesEng,
            "MaisInformacoesIta": MaisInformacoesIta,
            "MaisInformacoesPol": MaisInformacoesPol,
            "MaisInformacoesRus": MaisInformacoesRus,
            "Preco": Preco,
            "QtdRecomprada": QtdRecomprada,
            "StatusStr": StatusStr,
            "TipoEng": TipoEng,
            "TipoID": TipoID,
            "TipoIta": TipoIta,
            "TipoPol": TipoPol,
            "TipoRus": TipoRus,
            "DataAtualizacao": DataAtualizacao,
            "IDTipoOperacao": IDTipoOperacao,
            "NomeTipoOpcao_Rus": NomeTipoOpcao_Rus,
            "NomeTipoOpcao_Eng": NomeTipoOpcao_Eng,
            "PeriodoAviso": PeriodoAviso,
            "SpreadBenchmark": SpreadBenchmark,
            "DataLimite": DataLimite,
            "IDTipoEmitente": IDTipoEmitente,
            "DataInicioColocacao": DataInicioColocacao,
            "DataFimColocacao": DataFimColocacao,
            "IDStatusEmissao": IDStatusEmissao,
            "NomeEmitenteEng": NomeEmitenteEng,
            "NomeEmitenteRus": NomeEmitenteRus,
            "IDFilialEmitente": IDFilialEmitente,
            "IDTipoEmissao": IDTipoEmissao,
            "MercadoNegociacaoAtual": MercadoNegociacaoAtual
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            typeComponent: 'date',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataFechamento',
            headerName: 'DataFechamento',
            typeComponent: 'date',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataAbertura',
            headerName: 'DataAbertura',
            typeComponent: 'date',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'IDPaisEmitente',
            headerName: 'IDPaisEmitente',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'IDRegiaoPaisEmitente',
            headerName: 'IDRegiaoPaisEmitente',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'IDEmitente',
            headerName: 'IDEmitente',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'ISIN144a',
            headerName: 'ISIN144a',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'MaisInformacoesEng',
            headerName: 'MaisInformacoesEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'MaisInformacoesIta',
            headerName: 'MaisInformacoesIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'MaisInformacoesPol',
            headerName: 'MaisInformacoesPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'MaisInformacoesRus',
            headerName: 'MaisInformacoesRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'Preco',
            headerName: 'Preco',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 130,
        },
        {
            field: 'QtdRecomprada',
            headerName: 'QtdRecomprada',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'StatusStr',
            headerName: 'StatusStr',
            disableColumnMenu: true,
            flex: true,
            minWidth: 180,
        },
        {
            field: 'TipoEng',
            headerName: 'TipoEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'TipoID',
            headerName: 'TipoID',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 130,
        },
        {
            field: 'TipoIta',
            headerName: 'TipoIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'TipoPol',
            headerName: 'TipoPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'TipoRus',
            headerName: 'TipoRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'DataAtualizacao',
            headerName: 'DataAtualizacao',
            typeComponent: 'date',
            disableColumnMenu: true,
            flex: true,
            minWidth: 160,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'IDTipoOperacao',
            headerName: 'IDTipoOperacao',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 160,
        },
        {
            field: 'NomeTipoOpcao_Rus',
            headerName: 'NomeTipoOpcao_Rus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'NomeTipoOpcao_Eng',
            headerName: 'NomeTipoOpcao_Eng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'PeriodoAviso',
            headerName: 'PeriodoAviso',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'SpreadBenchmark',
            headerName: 'SpreadBenchmark',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 170,
        },
        {
            field: 'DataLimite',
            headerName: 'DataLimite',
            typeComponent: 'date',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'IDTipoEmitente',
            headerName: 'IDTipoEmitente',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'DataInicioColocacao',
            headerName: 'DataInicioColocacao',
            typeComponent: 'date',
            disableColumnMenu: true,
            flex: true,
            minWidth: 180,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataFimColocacao',
            headerName: 'DataFimColocacao',
            typeComponent: 'date',
            disableColumnMenu: true,
            flex: true,
            minWidth: 180,
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'IDStatusEmissao',
            headerName: 'IDStatusEmissao',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 160,
        },
        {
            field: 'NomeEmitenteEng',
            headerName: 'NomeEmitenteEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'NomeEmitenteRus',
            headerName: 'NomeEmitenteRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'IDFilialEmitente',
            headerName: 'IDFilialEmitente',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 160,
        },
        {
            field: 'IDTipoEmissao',
            headerName: 'IDTipoEmissao',
            type: 'number',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'MercadoNegociacaoAtual',
            headerName: 'MercadoNegociacaoAtual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 200,
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterCBondsOfferTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterCBondsOfferTable